$(document).ready(function(){
  setTimeout(function(){
    for (let i = 0; i < window.boostSDFallback.products.length; i++) {
      var dataTags = window.boostSDFallback.products[i].tags;
      var dataTitle = window.boostSDFallback.products[i].title;
      
      var coLabel = dataTags.includes('CO-ORDINATING ITEM');
      if (coLabel) {
        var gridItem = document.querySelectorAll('.boost-sd__product-item');
        
        gridItem.forEach(function(item){
          var itemHeading = item.getAttribute('.boost-sd__product-title').innerText;
          if (itemHeading === dataTitle) {
            
            var badge = document.createElement('div');
            badge.classList.add('co_ordinating_badge');
            badge.innerText = 'CO-ORDINATING ITEM';
            
            item.querySelector('.boost-sd__product-price').insertAdjacentElement('afterbegin', badge);
          }
        });
      }
    }
  }, 3000);
});

